import { FC, ReactElement } from 'react';
import { Tooltip } from '@material-ui/core';

import { Icon } from '@components';
import { useStyles, useTooltipStyles } from './SuccessMark.styles';

export const SuccessMark: FC<{
  title: string;
}> = ({ title }): ReactElement => {
  const styles = useStyles();
  const tooltipClasses = useTooltipStyles();

  return (
    <Tooltip disableFocusListener title={title} arrow placement="top-start" classes={tooltipClasses}>
      <span className={styles.exclamationMark}>
        <Icon.Tick />
      </span>
    </Tooltip>
  );
};
